<template>
  <v-app class="app-main-canvas">
    <NavBar />
    <router-view class="main-content-view px-2 py-9"/>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
export default {
  name: "WithNavbar",
  components: { NavBar },
};
</script>

<style>
.app-main-canvas.theme--light,
.app-main-canvas.theme--light .v-application--wrap,
.app-main-canvas.theme--light .main-content-view {
  background-color: #f8fafc !important;
}

.app-main-canvas.theme--dark,
.app-main-canvas.theme--dark .v-application--wrap,
.app-main-canvas.theme--dark .main-content-view {
  background-color: #0B0F19 !important;
}

.app-main-canvas .v-application--wrap {
  min-height: calc(100vh - 64px);
}

.main-content-view {
  min-height: calc(100vh - 64px);
}

.app-main-canvas .v-icon {
  background-color: transparent;
}

header.px-5.py-5.v-sheet.theme--dark.elevation-0.v-toolbar.v-app-bar.v-app-bar--fixed {
  padding: 0 !important;
  display: flex;
}

/* Soft / Smooth Scrolling & Momentum */
html {
  scroll-behavior: smooth;
}

html,
body,
.v-application,
.v-data-table__wrapper,
.stat-list-container {
  -webkit-overflow-scrolling: touch;
}

/* Custom Sleek Scrollbars (Fix Raw Browser Scrollbars) */
html::-webkit-scrollbar,
body::-webkit-scrollbar,
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background: transparent !important;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track,
::-webkit-scrollbar-track,
html::-webkit-scrollbar-track-piece,
body::-webkit-scrollbar-track-piece,
::-webkit-scrollbar-track-piece,
html::-webkit-scrollbar-corner,
body::-webkit-scrollbar-corner,
::-webkit-scrollbar-corner {
  background: transparent !important;
}

html::-webkit-scrollbar-button,
body::-webkit-scrollbar-button,
::-webkit-scrollbar-button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb,
::-webkit-scrollbar-thumb {
  background: #94A3B8;
  border-radius: 10px;
  transition: background-color 0.2s ease;
}

html::-webkit-scrollbar-thumb:hover,
body::-webkit-scrollbar-thumb:hover,
::-webkit-scrollbar-thumb:hover {
  background: #64748B;
}

/* Dark Mode Scrollbars */
html.theme--dark,
html.theme--dark body,
.theme--dark {
  color-scheme: dark !important;
}

html.theme--dark::-webkit-scrollbar,
html.theme--dark body::-webkit-scrollbar,
html.theme--dark ::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background: transparent !important;
}

html.theme--dark::-webkit-scrollbar-track,
html.theme--dark body::-webkit-scrollbar-track,
html.theme--dark ::-webkit-scrollbar-track,
html.theme--dark::-webkit-scrollbar-track-piece,
html.theme--dark body::-webkit-scrollbar-track-piece,
html.theme--dark ::-webkit-scrollbar-track-piece,
html.theme--dark::-webkit-scrollbar-corner,
html.theme--dark body::-webkit-scrollbar-corner,
html.theme--dark ::-webkit-scrollbar-corner {
  background: transparent !important;
}

html.theme--dark::-webkit-scrollbar-button,
html.theme--dark body::-webkit-scrollbar-button,
html.theme--dark ::-webkit-scrollbar-button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}

html.theme--dark::-webkit-scrollbar-thumb,
html.theme--dark body::-webkit-scrollbar-thumb,
html.theme--dark ::-webkit-scrollbar-thumb {
  background: #475569 !important;
  border-radius: 10px;
  transition: background-color 0.2s ease;
}

html.theme--dark::-webkit-scrollbar-thumb:hover,
html.theme--dark body::-webkit-scrollbar-thumb:hover,
html.theme--dark ::-webkit-scrollbar-thumb:hover {
  background: #64748B !important;
}
</style>
